import { Grid } from '@material-ui/core';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import BusinessIcon from '@material-ui/icons/Business';
import HealthAndSafetyIcon from '@material-ui/icons/Favorite';
import LinkIcon from '@material-ui/icons/Link';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import PublicIcon from '@material-ui/icons/Public';
import NetworkCheckIcon from '@material-ui/icons/NetworkCheck';
import BarChartIcon from '@material-ui/icons/BarChart';
import { QuickLinkCard, QuickLinkCardProps } from './QuickLinkCard';

/**
 * Curated set of home-page quick links. This array is intentionally
 * static — it lives in the same file as the renderer so reviewers can
 * see the home page's full link inventory in one diff.
 *
 * For admin-authored pages, the SAME `QuickLinkCard` primitive is
 * reused via the content-page widget registry — each card is a
 * `quick-link-card` widget in `spec.widgets` on a `ContentPage`
 * entity. See `packages/app/src/modules/contentPages/widgets.tsx`.
 */
const cards: QuickLinkCardProps[] = [
  {
    title: 'Latest TechDocs',
    primaryText: 'Browse',
    secondaryText: 'Search documentation across all your services',
    actionLabel: 'Open docs',
    actionUrl: '/docs',
    icon: <LibraryBooksIcon style={{ fontSize: 40 }} />,
    color: 'blue',
  },
  {
    title: 'Confluence',
    primaryText: 'Wiki',
    secondaryText: 'Team knowledge base, specs and meeting notes',
    actionLabel: 'Open Confluence',
    actionUrl:
      'https://inside-docupedia.bosch.com/confluence2/display/digitalfactory/Digital+Factory+-+Home',
    icon: <MenuBookIcon style={{ fontSize: 40 }} />,
    color: 'blue-light',
    external: true,
  },
  {
    title: 'Organization',
    primaryText: 'BISB-DF',
    secondaryText: 'Browse all projects in the Azure DevOps',
    actionLabel: 'View projects',
    actionUrl: 'https://dev.azure.com/BISB-DF/_projects',
    icon: <BusinessIcon style={{ fontSize: 40 }} />,
    color: 'blue-dark',
    external: true,
  },
  {
    title: 'Digital Factory',
    primaryText: 'Site',
    secondaryText: 'Official portal of the Bosch Digital Factory',
    actionLabel: 'Visit site',
    actionUrl: 'https://www.bosch-digitalfactory.com.br/',
    icon: <PublicIcon style={{ fontSize: 40 }} />,
    color: 'blue-dark',
    external: true,
  },
  {
    title: 'System Health',
    primaryText: 'Quality',
    secondaryText: 'Code quality and pipeline status overview',
    actionLabel: 'Check SonarQube',
    actionUrl: 'https://sonarqube.bosch-digital-factory.com',
    icon: <HealthAndSafetyIcon style={{ fontSize: 40 }} />,
    color: 'green',
    external: true,
  },
  {
    title: 'Uptime Kuma',
    primaryText: 'Uptime',
    secondaryText: 'Real-time status of all monitored services',
    actionLabel: 'Open monitor',
    actionUrl:
      'https://kuma.bosch-digital-factory.com/status/digital-factory-status',
    icon: <NetworkCheckIcon style={{ fontSize: 40 }} />,
    color: 'green-dark',
    external: true,
  },
  {
    title: 'Metabase',
    primaryText: 'FinOps',
    secondaryText: 'Dashboards, reports and ad-hoc data exploration',
    actionLabel: 'Open Metabase',
    actionUrl:
      'http://20.9.135.188:3000/public/dashboard/90d1aed6-01c2-43fe-972d-7ccafe024e5c',
    icon: <BarChartIcon style={{ fontSize: 40 }} />,
    color: 'gray',
    external: true,
  },
  {
    title: 'Quick Links',
    primaryText: 'Resources',
    secondaryText: 'Templates, guides and team resources',
    actionLabel: 'Create new',
    actionUrl: '/create',
    icon: <LinkIcon style={{ fontSize: 40 }} />,
    color: 'gray-dark',
  },
];

export const QuickStatsCards = () => {
  return (
    <Grid container spacing={2}>
      {cards.map(card => (
        <Grid key={card.title} item xs={12} sm={6} md={3}>
          <QuickLinkCard {...card} />
        </Grid>
      ))}
    </Grid>
  );
};
